// Centralized user-facing copy for API failures. Components must not display
// raw backend messages, network error text, or status codes — always show one
// of these instead, regardless of what the failed request actually returned.
// Each constant is scoped to the action that can fail, but still lives here so
// wording stays consistent and is never redefined ad hoc in a component.

export const GENERIC_ERROR_MESSAGE = "Something went wrong. Please try again later.";

export const OTP_SEND_ERROR_MESSAGE = "Unable to send the OTP. Please try again later.";
export const OTP_VERIFY_ERROR_MESSAGE = "Unable to verify the OTP. Please try again later.";
export const REGISTER_ERROR_MESSAGE = "Unable to complete registration. Please try again later.";

export const PRIVACY_POLICY_LOAD_ERROR_MESSAGE =
  "Failed to load the privacy policy. Please try again later.";
export const PRIVACY_POLICY_OPEN_ERROR_MESSAGE =
  "Failed to open the privacy policy. Please try again later.";

export const MAP_LOAD_ERROR_MESSAGE = "Failed to load the map. Please try again later.";
export const ROBOT_POSITION_SAVE_ERROR_MESSAGE =
  "Failed to save the robot's position. Please try again later.";

export const AD_DOWNLOAD_ERROR_MESSAGE =
  "Failed to download the advertisement. Please try again later.";
export const AD_DELETE_ERROR_MESSAGE =
  "Failed to delete the advertisement. Please try again later.";
export const AD_UPLOAD_ERROR_MESSAGE =
  "Failed to upload the advertisement. Please try again later.";

export const CHANGE_PASSWORD_ERROR_MESSAGE =
  "Failed to change your password. Please try again later.";
export const PROFILE_SAVE_ERROR_MESSAGE = "Failed to save your profile. Please try again later.";

export const SEARCH_ERROR_MESSAGE = "Failed to search. Please try again later.";

export const NOTIFICATIONS_LOAD_ERROR_MESSAGE =
  "Failed to load your notifications. Please try again later.";
